module.exports = __webpack_public_path__ + "img/footer-sm.da5ac5ed.png";